import { useLocation, Navigate } from "react-router-dom";
// material
import { styled } from '@mui/material/styles';
import { Stack, Container, Card, Typography } from '@mui/material';
// components
import Page from '../../../components/Page';
import ClientMaster from '../../../components/SidebarMenuComponents/MasterComponent/ClientMaster'
import ServiceWeightage from "../../../components/SidebarMenuComponents/ServiceComponent/ServiceWeightage";
// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 1)
}));
export default function ServiceWeightagePage() {
    const location = useLocation();
 
    return (
        <Page title="  Service Weightage | Smile Service" >
            <Typography variant="h5" color="#E7000B" marginLeft={3} marginTop={1} >
                Service Weightage
            </Typography>

            <ContentStyle>
                <ServiceWeightage />
            </ContentStyle>
        </Page>
    );
}

